import { render, staticRenderFns } from "./lista-produto.vue?vue&type=template&id=a3754e9e"
import script from "./lista-produto.vue?vue&type=script&lang=js"
export * from "./lista-produto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports